export const crmEmbedPalettes = [
  {
    key: 'ocean',
    label: '经典蓝',
    englishLabel: 'Ocean Blue',
    primary: '#2563eb',
    surface: '#f3f7ff',
    ink: '#10213c',
    muted: '#52657e',
  },
  {
    key: 'forest',
    label: '自然绿',
    englishLabel: 'Forest Green',
    primary: '#3f7d3a',
    surface: '#f2f8ef',
    ink: '#182814',
    muted: '#586b52',
  },
  {
    key: 'rose',
    label: '柔和粉',
    englishLabel: 'Soft Rose',
    primary: '#c24b69',
    surface: '#fff4f7',
    ink: '#3d1823',
    muted: '#7a5560',
  },
  {
    key: 'wisteria',
    label: '优雅紫',
    englishLabel: 'Wisteria Purple',
    primary: '#6d55c7',
    surface: '#f7f4ff',
    ink: '#251a46',
    muted: '#665c7f',
  },
  {
    key: 'sunset',
    label: '活力橙',
    englishLabel: 'Sunset Orange',
    primary: '#c6530f',
    surface: '#fff7ed',
    ink: '#3f2212',
    muted: '#775e4d',
  },
  {
    key: 'crimson',
    label: '品牌红',
    englishLabel: 'Crimson Red',
    primary: '#c83b45',
    surface: '#fff4f4',
    ink: '#3d171b',
    muted: '#77565a',
  },
  {
    key: 'teal',
    label: '清新青',
    englishLabel: 'Modern Teal',
    primary: '#167c75',
    surface: '#effaf8',
    ink: '#103532',
    muted: '#55716e',
  },
  {
    key: 'graphite',
    label: '高级黑',
    englishLabel: 'Graphite',
    primary: '#303846',
    surface: '#f5f6f8',
    ink: '#111827',
    muted: '#5b6472',
  },
] as const

export type CrmEmbedThemeKey = (typeof crmEmbedPalettes)[number]['key']

export const CRM_EMBED_DEFAULT_THEME_KEY: CrmEmbedThemeKey = 'ocean'

export const isCrmEmbedThemeKey = (value: unknown): value is CrmEmbedThemeKey =>
  crmEmbedPalettes.some((palette) => palette.key === value)

export const getCrmEmbedPalette = (key?: string) =>
  crmEmbedPalettes.find((palette) => palette.key === key) || crmEmbedPalettes[0]
